import React, { Component } from "react";
import { DataTable } from "primereact/components/datatable/DataTable";
import { Column } from "primereact/components/column/Column";
//import { ProgressSpinner } from "primereact/components/progressspinner/ProgressSpinner";
import { Button } from "primereact/components/button/Button";
import { Growl } from "primereact/components/growl/Growl";
import { Dialog } from "primereact/components/dialog/Dialog";

//Imports from common
import { api } from "../../common/CloudService/ApiPromisify";
import { CloudService } from "../../common/CloudService/ClientLibsReference";
import { LoadScreen } from "../Common/LoadScreen";
//import { formatId } from "../../common/FormatId";

export class Contractors extends Component {
  constructor() {
    super();
    this.state = {
      loaded: false,
      test: "",
      contractorList: [],
      contractorSelected: false,
      contractorEdited: false,
      contractorAdded: false,
      contractorDeleted: false,
      selectedContractor: "",
      contractorAddressLine1: "",
      contractorAddressLine2: "",
      contractorBusinessDescription: "",
      contractorBusinessName: "",
      contractorCity: "",
      contractorCodeTag: "",
      contractorCountryCode: "",
      contractorCurrency: "",
      contractorCurrencyDecimalPlaces: "",
      contractorCurrencySymbol: "",
      contractorId: "",
      contractorLastUpdatedDateTime: "",
      contractorOpeningHours: "",
      contractorPostalZipCode: "",
      contractorTimezone: "",
      contractorType: "",
      contractorTelephoneNumber: "",
      contractorEmail: "",
      editedContractorBusinessName: "",
      editedContractorAddressLine1: "",
      editedContractorAddressLine2: "",
      editedContractorPostalZipCode: "",
      editedContractorCity: "",
      editedContractorEmail: "",
      editedContractorTelephoneNumber: ""
    };
  }

  componentDidMount() {
    this.getContractors();
  }

  getContractors = async () => {
    this.setState({ loaded: false });

    let businessRequest = new CloudService.BusinessRequest();
    businessRequest.codeTag = localStorage.getItem("codeTag");
    businessRequest.type = "Supplier";

    await api("businessApiV1BusinesslistByType", businessRequest).then(res => {
      let businessResponse = CloudService.BusinessResponse.constructFromObject(
        res.data
      );
      console.log(businessResponse);

      if (businessResponse.errorCode === 0) {
        this.setState({
          contractorList: businessResponse.businesses
        });
      } else {
        this.growl.show({
          severity: "error",
          summary: "Error",
          detail:
            "An error occured retrieving data, please refresh and try again",
          life: 3000
        });
      }
    });

    this.setState({ loaded: true });
  };

  editContractor = async () => {
    this.setState({ loaded: false });

    let businessRequest = new CloudService.BusinessRequest();
    businessRequest.codeTag = this.state.contractorId;
    businessRequest.lastUpdatedDateTime = this.state.contractorLastUpdatedDateTime;
    if (
      this.state.editedContractorBusinessName !==
      this.state.contractorBusinessName
    ) {
      businessRequest.businessName = this.state.editedContractorBusinessName;
    }
    businessRequest.addressLine1 = this.state.editedContractorAddressLine1;
    businessRequest.addressLine2 = this.state.editedContractorAddressLine2;
    businessRequest.postalZipCode = this.state.editedContractorPostalZipCode;
    businessRequest.city = this.state.editedContractorCity;
    businessRequest.email = this.state.editedContractorEmail;
    businessRequest.telephoneNumber = this.state.editedContractorTelephoneNumber;

    await api("businessApiV1BusinessUpdate", businessRequest).then(res => {
      let businessResponse = CloudService.BusinessResponse.constructFromObject(
        res.data
      );
      console.log(businessResponse);

      if (businessResponse.errorCode === 0) {
        this.setState({
          contractorEdited: false
        });
        this.growl.show({
          severity: "success",
          summary: "Success",
          detail: "Contractor successfully updated",
          life: 3000
        });
        this.getContractors();
      } else {
        this.setState({ loaded: true });
        this.growl.show({
          severity: "error",
          summary: "Error",
          detail: "An error occured updating the contractor, please try again",
          life: 3000
        });
      }
    });
  };

  addContractor = async () => {
    this.setState({ loaded: false });

    let businessRequest = new CloudService.BusinessRequest();
    businessRequest.businessName = this.state.editedContractorBusinessName;
    businessRequest.addressLine1 = this.state.editedContractorAddressLine1;
    businessRequest.addressLine2 = this.state.editedContractorAddressLine2;
    businessRequest.postalZipCode = this.state.editedContractorPostalZipCode;
    businessRequest.city = this.state.editedContractorCity;
    businessRequest.email = this.state.editedContractorEmail;
    businessRequest.telephoneNumber = this.state.editedContractorTelephoneNumber;
    businessRequest.type = "Supplier";
    businessRequest.timezone = "GMT";
    businessRequest.currency = "GBP";
    businessRequest.countryCode = "GBR";
    businessRequest.configJsonStr = JSON.stringify({ "": "" });

    await api("businessApiV1CreateBusiness", businessRequest).then(res => {
      let businessResponse = CloudService.BusinessResponse.constructFromObject(
        res.data
      );
      console.log(businessResponse);

      if (businessResponse.errorCode === 0) {
        this.setState({
          contractorEdited: false,
          contractorAdded: false
        });
        this.growl.show({
          severity: "success",
          summary: "Success",
          detail: "Contractor successfully created",
          life: 3000
        });
        this.getContractors();
      } else {
        this.setState({ loaded: true });
        this.growl.show({
          severity: "error",
          summary: "Error",
          detail: "An error occured creating the contractor, please try again",
          life: 3000
        });
      }
    });
  };

  deleteContractor = async () => {
    this.setState({ loaded: false });

    let businessRequest = new CloudService.BusinessRequest();
    businessRequest.codeTag = this.state.contractorId;
    businessRequest.lastUpdatedDateTime = this.state.contractorLastUpdatedDateTime;
    businessRequest.businessName = this.state.contractorBusinessName;

    await api("businessApiV1EraseBusiness", businessRequest).then(res => {
      let businessResponse = CloudService.BusinessResponse.constructFromObject(
        res.data
      );
      console.log(businessResponse);

      if (businessResponse.errorCode === 0) {
        this.setState({
          contractorSelected: false
        });
        this.growl.show({
          severity: "success",
          summary: "Success",
          detail: "Contractor successfully deleted",
          life: 3000
        });
        this.getContractors();
      } else {
        this.setState({ loaded: true });
        this.growl.show({
          severity: "error",
          summary: "Error",
          detail: "An error occured deleting the contractor, please try again",
          life: 3000
        });
      }
    });
  };

  render() {
    return (
      <div className="ui-g dashboard">
        <Growl style={{ textAlign: "left" }} ref={el => (this.growl = el)} />
        <Dialog
          header="Delete Supplier"
          footer={
            <div>
              <Button
                label="Yes"
                onClick={() => {
                  this.setState({ contractorDeleted: false });
                  this.deleteContractor();
                }}
                style={{
                  float: "right",
                  color: "white",
                  backgroundColor: "#01a4ef"
                }}
              />
              <Button
                label="No"
                onClick={() => {
                  this.setState({ contractorDeleted: false });
                }}
                style={{
                  float: "right",
                  color: "white",
                  backgroundColor: "#808080"
                }}
              />
            </div>
          }
          visible={this.state.contractorDeleted}
          style={{ width: "50vw" }}
          modal={true}
          onHide={e => this.setState({ contractorDeleted: false })}
        >
          Are you sure you want to delete?
        </Dialog>
        {this.state.loaded === false ? (
          <LoadScreen />
        ) : (
          <div className="ui-g-12">
            {/*Contractors Card*/}
            {this.state.contractorSelected === false ? (
              <label />
            ) : (
              <div className="ui-g-12 card">
                <div className="ui-g-12">
                  {/*Empty div for spacing*/}
                  <label />
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-4">
                    <b>Name: </b>
                    <label>
                      {this.state.contractorBusinessName || "Not Set"}
                    </label>
                  </div>
                  <div className="ui-g-4">
                    <b>Address Line 1: </b>
                    <label>
                      {this.state.contractorAddressLine1 || "Not Set"}
                    </label>
                  </div>
                  <div className="ui-g-4">
                    <b>Address Line 2: </b>
                    <label>
                      {this.state.contractorAddressLine2 || "Not Set"}
                    </label>
                  </div>
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-4">
                    <b>Postcode: </b>
                    <label>
                      {this.state.contractorPostalZipCode || "Not Set"}
                    </label>
                  </div>
                  <div className="ui-g-4">
                    <b>City: </b>
                    <label>{this.state.contractorCity || "Not Set"}</label>
                  </div>
                  <div className="ui-g-4">
                    <b>Email: </b>
                    <label>{this.state.contractorEmail || "Not Set"}</label>
                  </div>
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-4">
                    <b>Contact Telephone: </b>
                    <label>
                      {this.state.contractorTelephoneNumber || "Not Set"}
                    </label>
                  </div>
                </div>
                <div className="ui-g-12">
                  <Button
                    label="Edit"
                    onClick={() => {
                      this.setState({
                        contractorSelected: false,
                        contractorEdited: true,
                        contractorAdded: false,
                        editedContractorBusinessName: this.state
                          .contractorBusinessName,
                        editedContractorAddressLine1: this.state
                          .contractorAddressLine1,
                        editedContractorAddressLine2: this.state
                          .contractorAddressLine2,
                        editedContractorPostalZipCode: this.state
                          .contractorPostalZipCode,
                        editedContractorCity: this.state.contractorCity,
                        editedContractorEmail: this.state.contractorEmail,
                        editedContractorTelephoneNumber: this.state
                          .contractorTelephoneNumber
                      });
                    }}
                    style={{ float: "right" }}
                  />
                  <Button
                    label="Delete"
                    onClick={() => {
                      this.setState({ contractorDeleted: true });
                    }}
                    style={{ float: "right" }}
                  />
                  <Button
                    className="secondary-btn"
                    label="View Users"
                    onClick={() => {
                      localStorage.setItem(
                        "contractorId",
                        this.state.contractorId
                      );
                      window.location = "#/contractorUsers";
                    }}
                    style={{ float: "right" }}
                  />
                </div>
              </div>
            )}

            {/*Editing Contractors Card*/}
            {this.state.contractorEdited === false ? (
              <label />
            ) : (
              <div className="ui-g-12 card">
                <div className="ui-g-12">
                  {/*Empty div for spacing*/}
                  <label />
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-4">
                    <span className="md-inputfield form-field">
                      <input
                        className={
                          this.state.editedContractorBusinessName === "" ||
                          this.state.editedContractorBusinessName === undefined
                            ? "ui-inputtext"
                            : "ui-inputtext ui-state-filled"
                        }
                        type="text"
                        value={this.state.editedContractorBusinessName || ""}
                        onChange={e =>
                          this.setState({
                            editedContractorBusinessName: e.target.value
                          })
                        }
                      />
                      <label>Name *</label>
                    </span>
                  </div>
                  <div className="ui-g-4">
                    <span className="md-inputfield form-field">
                      <input
                        className={
                          this.state.editedContractorAddressLine1 === "" ||
                          this.state.editedContractorAddressLine1 === undefined
                            ? "ui-inputtext"
                            : "ui-inputtext ui-state-filled"
                        }
                        type="text"
                        value={this.state.editedContractorAddressLine1 || ""}
                        onChange={e =>
                          this.setState({
                            editedContractorAddressLine1: e.target.value
                          })
                        }
                      />
                      <label>Address Line 1 *</label>
                    </span>
                  </div>
                  <div className="ui-g-4">
                    <span className="md-inputfield form-field">
                      <input
                        className={
                          this.state.editedContractorAddressLine2 === "" ||
                          this.state.editedContractorAddressLine2 === undefined
                            ? "ui-inputtext"
                            : "ui-inputtext ui-state-filled"
                        }
                        type="text"
                        value={this.state.editedContractorAddressLine2 || ""}
                        onChange={e =>
                          this.setState({
                            editedContractorAddressLine2: e.target.value
                          })
                        }
                      />
                      <label>Address Line 2</label>
                    </span>
                  </div>
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-4">
                    <span className="md-inputfield form-field">
                      <input
                        className={
                          this.state.editedContractorPostalZipCode === "" ||
                          this.state.editedContractorPostalZipCode === undefined
                            ? "ui-inputtext"
                            : "ui-inputtext ui-state-filled"
                        }
                        type="text"
                        value={this.state.editedContractorPostalZipCode || ""}
                        onChange={e =>
                          this.setState({
                            editedContractorPostalZipCode: e.target.value
                          })
                        }
                      />
                      <label>Postcode *</label>
                    </span>
                  </div>
                  <div className="ui-g-4">
                    <span className="md-inputfield form-field">
                      <input
                        className={
                          this.state.editedContractorCity === "" ||
                          this.state.editedContractorCity === undefined
                            ? "ui-inputtext"
                            : "ui-inputtext ui-state-filled"
                        }
                        type="text"
                        value={this.state.editedContractorCity || ""}
                        onChange={e =>
                          this.setState({
                            editedContractorCity: e.target.value
                          })
                        }
                      />
                      <label>City *</label>
                    </span>
                  </div>
                  <div className="ui-g-4">
                    <span className="md-inputfield form-field">
                      <input
                        className={
                          this.state.editedContractorEmail === "" ||
                          this.state.editedContractorEmail === undefined
                            ? "ui-inputtext"
                            : "ui-inputtext ui-state-filled"
                        }
                        type="text"
                        value={this.state.editedContractorEmail || ""}
                        onChange={e =>
                          this.setState({
                            editedContractorEmail: e.target.value
                          })
                        }
                      />
                      <label>Email *</label>
                    </span>
                  </div>
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-4">
                    <span className="md-inputfield form-field">
                      <input
                        className={
                          this.state.editedContractorTelephoneNumber === "" ||
                          this.state.editedContractorTelephoneNumber ===
                            undefined
                            ? "ui-inputtext"
                            : "ui-inputtext ui-state-filled"
                        }
                        type="text"
                        value={this.state.editedContractorTelephoneNumber || ""}
                        onChange={e =>
                          this.setState({
                            editedContractorTelephoneNumber: e.target.value
                          })
                        }
                      />
                      <label>Contact Telephone *</label>
                    </span>
                  </div>
                </div>
                <div className="ui-g-12">
                  <Button
                    label="Save"
                    onClick={() => {
                      this.state.contractorAdded === true
                        ? this.addContractor()
                        : this.editContractor();
                    }}
                    style={{ float: "right" }}
                  />
                  <Button
                    label="Cancel"
                    onClick={() => {
                      this.state.contractorAdded === true
                        ? this.setState({
                            contractorSelected: false,
                            contractorEdited: false,
                            contractorAdded: false
                          })
                        : this.setState({
                            contractorSelected: true,
                            contractorEdited: false,
                            contractorAdded: false
                          });
                    }}
                    style={{ float: "right" }}
                  />
                </div>
              </div>
            )}

            {/*Clients Table*/}
            <div className="ui-g-12 card">
              <DataTable
                value={this.state.contractorList}
                selectionMode="single"
                onSelectionChange={e => {
                  this.setState(
                    {
                      contractorSelected: true,
                      contractorEdited: false,
                      contractorAdded: false,
                      selectedContractor: e.data,
                      contractorAddressLine1: e.data.addressLine1,
                      contractorAddressLine2: e.data.addressLine2,
                      contractorBusinessDescription: e.data.businessDescription,
                      contractorBusinessName: e.data.businessName,
                      contractorCity: e.data.city,
                      contractorCodeTag: e.data.codeTag,
                      contractorCountryCode: e.data.countryCode,
                      contractorCurrency: e.data.currency,
                      contractorCurrencyDecimalPlaces:
                        e.data.currencyDecimalPlaces,
                      contractorCurrencySymbol: e.data.currencySymbol,
                      contractorId: e.data.id,
                      contractorLastUpdatedDateTime: e.data.lastUpdatedDateTime,
                      contractorOpeningHours: e.data.openingHours,
                      contractorPostalZipCode: e.data.postalZipCode,
                      contractorTimezone: e.data.timezone,
                      contractorType: e.data.type,
                      contractorTelephoneNumber: e.data.telephoneNumber,
                      contractorEmail: e.data.email
                    },
                    () => {
                      console.log(this.state.selectedContractor);
                    }
                  );
                }}
                header="Suppliers"
                autoLayout={true}
                paginator={true}
                alwaysShowPaginator={true}
                rows={10}
                emptyMessage="No Suppliers"
              >
                <Column
                  field="businessName"
                  header="Name"
                  sortable={true}
                  filter={true}
                  style={{ overflow: "auto" }}
                />
                <Column
                  field="addressLine1"
                  header="Address Line 1"
                  sortable={true}
                  filter={true}
                  style={{ overflow: "auto" }}
                />
                <Column
                  field="addressLine2"
                  header="Address Line 2"
                  sortable={true}
                  filter={true}
                  style={{ overflow: "auto" }}
                />
                <Column
                  field="telephoneNumber"
                  header="Contact Telephone"
                  sortable={true}
                  filter={true}
                  style={{ overflow: "auto" }}
                />
                <Column
                  field="city"
                  header="City"
                  sortable={true}
                  filter={true}
                  style={{ overflow: "auto" }}
                />
                <Column
                  field="email"
                  header="Email"
                  sortable={true}
                  filter={true}
                  style={{ overflow: "auto" }}
                />
              </DataTable>
            </div>
            <div className="ui-g-12">
              <Button
                label="Create New"
                onClick={() => {
                  this.setState({
                    contractorSelected: false,
                    contractorEdited: true,
                    contractorAdded: true,
                    editedContractorBusinessName: "",
                    editedContractorAddressLine1: "",
                    editedContractorAddressLine2: "",
                    editedContractorPostalZipCode: "",
                    editedContractorCity: "",
                    editedContractorEmail: "",
                    editedContractorTelephoneNumber: ""
                  });
                }}
                style={{ float: "right" }}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Contractors/Contractors.js